export { default } from "./FilterBox";



/** WEBPACK FOOTER **
 ** ./src/components/FilterBox/index.js
 **/